// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import routeConfig from './router/routeConfig'
import { Tooltip } from 'element-ui';
// 依赖
import axios from 'axios'
import iview from 'view-design'
import 'view-design/dist/styles/iview.css'
import locale from 'view-design/dist/locale/en-US'
import * as echarts from 'echarts'
import moment from 'moment'
import momentTimezone from 'moment-timezone';
import 'cropper'
import 'cropper/dist/cropper.js'
import 'cropper/dist/cropper.css'
import * as signalr from '@microsoft/signalr'
import md5 from 'js-md5'
import VueQuillEditor from 'vue-quill-editor'
/*富文本编辑器*/
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '../admin/assets/js/jQuery.print'
import videojs from './assets/videojs/video.min'
import './assets/videojs/video-js.min.css'
/*打印插件*/
import jsbarcode from 'jsbarcode'
/*条形码生成*/
//公钥加密
import JsEncrypt from 'jsencrypt'
// 自定义js
import tag from './components/commonComponents/tag.vue'
import utmEllipsis from './components/commonComponents/utmEllipsis.vue'
import utmShowImage from './components/commonComponents/utmShowImage.vue'
import utmLoading from './components/commonComponents/utmLoading.vue'
import utmNode from './components/commonComponents/utmSelectNode.vue'
import utmOffice from './components/commonComponents/utmSelectOffice.vue'
import utmFingerprint from './components/commonComponents/utmFingerprint.vue'
import utmModal from './components/commonComponents/utmModal.vue'
import utmScrollSelect from './components/commonComponents/scrollSelect.vue'
import './assets/js/jquery-ui.min.js'
import common from './assets/js/common.js'
import ApiService from './assets/js/ApiService.js'
import phoneCode from './assets/js/phoneCode.js'
import messageNotice from './assets/js/messageNotice.js'
import times from './assets/js/times.js'
import connect from './assets/js/notification.js'
import shareApi from './assets/js/shareAPI.js'
import menuData from './assets/js/menu.js'
import './directives/role.js'/*权限与下拉滚动加载*/
import merge from 'webpack-merge';
import veeValidate from '../admin/assets/js/validateConfig.js'
import psimIcon from './components/commonComponents/psimFontIcon.vue'
import IviewTable from './components/commonComponents/table/table.vue'
import IviewTansfer from './components/commonComponents/transfer/index.js'
import IconSelect from './components/commonComponents/select/select.vue'
import IconOption from './components/commonComponents/select/option.vue'
import statisticPeopleCounting from './components/commonComponents/statisticPeopleCounting.vue'
import palmVein from './components/commonComponents/palmVein.vue'
import 'element-ui/lib/theme-chalk/index.css';
import { Loading } from 'element-ui';

import '../../static/font/iconfont.js'
import '../admin/assets/css/utmFont.css'
import '../admin/assets/css/formStyle.css'
import '../admin/assets/css/common.css'
/*symbol图标*/

// vxe-table表格
import XEUtils from 'xe-utils'
import {VXETable,Grid,Column,Table,Tooltip} from 'vxe-table'
import 'vxe-table/lib/style.css'
import enUS from 'vxe-table/lib/locale/lang/en-US'

Vue.use(Grid).use(Column).use(Table).use(Tooltip);
VXETable.renderer.add('VxeNoData', {
  // 空内容模板
  renderEmpty (h) {
    return h('div', { class: 'utm-table-nodata' }, [
      h('svg', { class: 'utm-symbol-font', attrs: { 'aria-hidden': 'true' } }, [
        h('use', { attrs: { 'xlink:href': '#iconIllustration-Nodata-50' } })
      ]),
      h('p', 'No Data')
    ]);
  }
});
VXETable.renderer.add('VxeLoading', {
  // 空内容模板
  renderEmpty (h) {
    return h('div', { class: 'utm-custom-loading utm-table-loading'}, 'Loading');
  }
});
// 全局设置
VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(enUS, key), args),
  table:{
    showOverflow:'ellipsis',
    scrollY:{
      mode: 'virtual',  // 改为虚拟滚动模式
      oSize: 10,        // 增加缓冲区大小
      gt:  10   
    },
    scrollX: {
      mode: 'virtual',
      oSize: 10,  
      gt: 10
    },
    sortConfig: {
      remote: true,
      trigger: 'cell',
      orders: ['asc', 'desc'],
    },
    rowConfig:{
      isHover: true
    },
    columnConfig: {
      useVirtual: true,
      resizable: false
    },
    scrollConfig: {
      virtualScrolling: true,
      virtualMode: 'continuous',
      scrollToTopOnReload: true,
      scrollToRowOnChange: true,
      stopPropagation: true,
    }
  }
});

Vue.config.productionTip = false;
Vue.use(iview, {locale});
Vue.use(veeValidate.validator, veeValidate.config);
Vue.use(VueQuillEditor);
Vue.use(Tooltip);
Vue.use(Loading)
Vue.use(Loading.directive)
// CSS
// 全局注册组件
import {Cascader,Tree, Tooltip} from 'element-ui'
import * as ElLang from 'element-ui/lib/locale/lang/en'
import * as ElLocale from 'element-ui/lib/locale'
ElLocale.default.use(ElLang.default)
import './assets/css/elCascader.css'
Vue.use(Tree)
Vue.component(Cascader.name, Cascader);
Vue.component(Tooltip.name, Tooltip);
Vue.component('tag',tag);
Vue.component('utm-ellipsis',utmEllipsis);
Vue.component('utm-show-image',utmShowImage);
Vue.component('utm-loading',utmLoading);
Vue.component('utm-node',utmNode);
Vue.component('utm-office',utmOffice);
Vue.component('utm-fingerprint',utmFingerprint);//指纹录入
Vue.component('utm-modal', utmModal); 
Vue.component('psim-icon', psimIcon);
Vue.component('utm-scroll-select', utmScrollSelect);
Vue.component('people-counting',statisticPeopleCounting);
Vue.component(IviewTable.name, IviewTable); // Iview Table覆盖
Vue.component(IviewTansfer.name,IviewTansfer)
Vue.component('IconSelect',IconSelect);//选择后显示图标的下拉Select
Vue.component('IconOption',IconOption);//选择后显示图标的下拉Option
Vue.component('palm-Vein', palmVein);//掌纹

window.eventBus = new Vue();
Vue.prototype.ApiService = ApiService;
/*认证服务*/
Vue.prototype.phoneCode = phoneCode;
/*电话区号*/
Vue.prototype.messageNotice = messageNotice;
/*通知*/
Vue.prototype.$ajax = axios;
Vue.prototype.$echarts = echarts;
Vue.prototype.times = times;
/*时间格式*/
Vue.prototype.signalr = signalr;
/*消息推送连接*/
Vue.prototype.$md5 = md5;
Vue.prototype.common = common;
Vue.prototype.connect = connect;
Vue.prototype.shareApi = shareApi;
Vue.prototype.moment = moment;
Vue.prototype.momentTimezone = momentTimezone;
Vue.prototype.jsbarcode = jsbarcode;
Vue.prototype.videojs = videojs;
Vue.prototype.jsEncrypt = JsEncrypt;//rsa加密
Vue.prototype.merge = merge; //路由获取参数
import defaultImg from './assets/img/user/default-user.png'
/* eslint-disable no-new */
let _this, updateTokenTimer = null;
let vm = new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  data() {
    _this = this;

    function getLocalTimezoneWithOffset() {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const offset = new Date().getTimezoneOffset(); // 以分钟为单位

      // 计算为小时和分钟
      const offsetHours =  Math.abs(Math.floor(offset / 60));
      const offsetMinutes = Math.abs(offset % 60);

      // 格式化偏移量字符串
      const offsetSign = offset > 0 ? '-' : '+';
      let offsetHourStr = offsetHours > 9 ? '' + offsetHours : '0' + offsetHours;
      let offsetMinStr = offsetMinutes > 9 ? '' + offsetMinutes : '0' + offsetMinutes;
      const formattedOffset = `UTC${offsetSign}${offsetHourStr}:${offsetMinStr}`;

      return {
        timezoneId: `${timezone}`,
        timezoneName: formattedOffset
      };
    }

    return {
      // 添加这个全局配置是因为健康检测的一个路由bug 由于健康检测的子菜单以前是第四级目录
      //然后tab的切换使用的是组件的形式而不是路由，当切换tab的时候上面的面包屑导航不会进行切换，出现了bug
      //但是如果将其改为路由的形式的话，感觉很麻烦所以进行判断如果是

      // 这些路由需要进行面包屑处理
      healthMonitoringChangeNavTitle:['/healthList','/Dashboard','/customHealthManagement','/ServerAnalyze','/incidentProcess'],
      //默认的导航数据
      // title标题 必填
      // fun点击事件 必填
      healthMonitoringNavTitle:[{
        title:'Health Monitoring',
        fun:()=>{}
      },{
        title:'Infrastructure',
        fun:()=>{
          this.$router.push({ path: "/healthList", query: { child: 0 } });
        }
      },{
        title:'Server',
        fun:()=>{
          this.$router.push({ path: "/healthList", query: { child: 0 } });
        }
      }],
      isLatestHealth:window.g.isLatestHealth,//是否使用升级版健康检查
      // 事件处理模式是否是ESOP处理模式
      isESOPMode: false,
      common: common,
      currentTimeZone: getLocalTimezoneWithOffset(),
      //默认图片路径
      fileBaseUrl: window.g.FILE_ROOT,
      base64BaseUrl: 'data:image/png;base64,',
      baseUrl: window.g.FILE_ROOT + 'Files/Get/',
      //设置时间格式
      Time: {
        type: 'singapore',
        china: times.china,//中文
        singapore: times.singapore,//新加坡
      },
      //菜单
      menu: {
        shrink: 0,
        menuList: [],
        navTitle: "",
        childTitle: "",
        thirdTitle: "",
        forthTitle: "",
        childTitleText: ""
      },
      requestCount: 0,//接口请求数量
      isLoading: false, /*遮罩层*/
      loadingTimer: null, /*隐藏loading的定时器，用于防止两个接口先后调用时加载层快速闪烁*/
      loadingTimerDuration:50,
      //消息
      unreadMessageCount:0,
      allUnreadMessage:[],
      //动态通知
      isNotification:false,//是否存在新的动态通知
      adminInfo: {
        permissionCodes:[] //权限code
      },//用户
      contentWidth: '', /*内容区域宽度*/
      contentHeight: '', /*内容区域高度*/
      licenseExpiredModal:false,
      //查看大图
      viewBigImage: {
        bigImgModal: false,
        srcStr: ""
      },
      tableMaxHeight: window.innerHeight - 311, /*table显示最大高度*/
      isTablePagerfixed: false,
      tableHeight: '', /*table当前高度*/
      printTemplate: {
        /*用户打印模板*/
        editFlag: false,
        saveTipModal: false
      },
      icKeepFigures:0,/*IC卡保留位数*/
      loginModal:false,
      swipeCardInfo:{},/*刷卡信息*/
      isUpdateFlag:true,
      nodes:[], /*所有节点(不包含虚拟节点All)*/
      navNodes:[],/* 用户界面导航栏的节点 */
      curNodeInfo: {id: null, name: 'All'}, //当前节点,默认切换到虚拟节点All
      masterNodeInfo: {},//主节点的信息,主要用于选择All虚拟节点时，查询配置中心的信息
      navOffices:[],
      offices:[],
      curOfficeInfo:{},
      ischangeOffice:true,
      curNodeInfoUpdated: false, //当前节点信息是否已更新
      cancelReq:null,/*取消接口请求*/
      reconnectTime:window.g.reconnectTime || 30000,
      isResetPassword: false,
      defaultCheckZone: ["L1","L2","L20","L37","L38","L60"],
      loadPerPage:10,/* 动态加载每页数量 */
      timeOutModal:false,
      defaultImg:defaultImg,
      healthMenuListCode:['M_Overview','M_Dashboard','M_Infrastructure','M_Health_Server_Analyze','M_Health_Custom_management','M_tile_management','M_tile_Map_Management','M_Add_tile_Map','M_IsolateManagement'],
      isExpireLicense:false,//License是否快过期
      // 当切换了office数据于office不匹配时需要退出当前界面，刷新数据
      changeOfficeSystemModal:false,
      currentNode:null,//同样是当前节点信息只是多了他的主节点是否是esop的参数,这个数据是通过接口getCurrentNode获取的
      detailLinkId:'',
      incidentIsHidden: window.g.incidentIsHidden, // 是否隐藏事件处理相关
    }
  },
  beforeMount() {
    _this = this;
    _this.ApiService.getLocalToken();
    this.setInterceptor();
    this.getAll();
  },
  beforeCreate(){
    if(window.location.href.indexOf('detailLinkId') != -1){
      const urlParams = new URLSearchParams(window.location.search);
      let detailLinkId = urlParams.get('detailLinkId');
      if (detailLinkId) {
        detailLinkId = detailLinkId.replace(/#\/$/, ''); // 去除结尾的 #/
      };
      this.detailLinkId = detailLinkId
      window.sessionStorage.setItem('detailLinkId',detailLinkId);
      if(localStorage.getItem('essAccessToken') || localStorage.getItem('isAdLogin') == 'true'){
        if(localStorage.getItem('isAdLogin') == 'true'){
          window.location.replace(window.location.origin + '/#/myAlarm?keywork=waitToIncident')
        }else{
          // 将字符串转换为 Date 对象
         const dateString =localStorage.getItem('essRefreshTime');
         if(!dateString){
           window.location.replace(window.location.origin + '/#/login')
         }else{
           const targetDate = moment(dateString).valueOf()
           // 获取当前时间
           const currentDate = new Date().getTime();
           if (targetDate > currentDate) {
             window.location.replace(window.location.origin + '/#/myAlarm?keywork=waitToIncident')
           } else {
             window.location.replace(window.location.origin + '/#/login')
           }
         }
        }
      }else{
        window.location.replace(window.location.origin + '/#/login')
      }
    }
  },


  methods: {
    // 通过后端接口判断是否是esop模式
    async setIsEsopMode(){
      let res = await this.$ajax.get('Incident/IsEsopModel')
      if(res.data.success){
          this.isESOPMode = res.data.data;
      }else{
       this.isESOPMode = false
      }
    },
    // 判断是否是HQ节点 ,如果是HQ节点则隐藏事件处理相关
    async isHQ(){
      if(_this.incidentIsHidden){
        /** start Incident Management权限列表 */
        // Incident Management
        const incidentManagementCodes = ['N_Incident','N_IncidentIncidentManagement']
        // Incident Alarm
        const incidentAlarmPermissions = ['M_IncidentAlarm','M_AddIncidentAlarm','M_EditIncidentAlarm', 'M_ESOPTemplateManagement','M_AddESOPTemplate','M_EditESOPTemplate']
        // System Notification
        const systemNotificationPermissions = ['M_Notification','M_AddNotification','M_EditNotification','M_DeleteNotification']
        // Task
        const taskPermissions = ['M_Task','M_AddTask','M_EditTask','M_DeleteTask']
        // Customised Incident
        const customisedPermissions =  ['M_CustomisedIncident','M_AddCustomisedIncident','M_EditCustomisedIncident']
        /** end Incident Management */

        /** M_MyAlarm菜单权限 */
        const myAlarmPermissions = ['N_IncidentMyIncident','M_MyAlarm','M_MyNotification','M_MyTask','M_ProcessAlarm','M_ReportIncident']
        const allPermissions = [...incidentManagementCodes, ...incidentAlarmPermissions, ...systemNotificationPermissions, ...taskPermissions, ...customisedPermissions, ...myAlarmPermissions]
        // 取消对应按钮及页面权限
        _this.adminInfo.permissionCodes = _this.adminInfo.permissionCodes.filter(item=> !allPermissions.includes(item))
      }
    },
    // 获取当前节点信息
    getCurrentNode(){
      _this.$ajax.get('SyncNode/GetCurrentNode',{headers:{noLoading:true}}).then((res)=>{
        _this.currentNode = res.data.data
      })
    },
    // 处理事件中一些按钮的判断,如果主节点是esop模式,那么子节点myAlarm节点将无法处理事件记录,并且无法添加事件
    // 父节点是esop 当前节点不是父节点 我隐藏
    handlerIncident(){
      if(this.currentNode.isEsopModel && !this.currentNode.isMaster){
           return false
      }
      return true
    },
    //获取用户信息
    getUserInfo: function (callback) {
      this.ApiService.refreshFlag = false;
      this.timeOutModal = false;
      _this.isUpdateFlag = false;
      //获取用户信息的时候要判断是手动输入账号登录还是AD账号
      let source = _this.ApiService.isAdLogin ? 'AD':'Ultimo';
      this.$ajax.get('Accounts/GetLoginAccountInfo?source=' + source,{baseURL: window.g.VERIFICATION_ROOT}).then((res) => {
        if(res.data.success){
          _this.$root.loginModal = false;
          let result = res.data.data;
          _this.adminInfo = result;
          if(_this.adminInfo.isNeedResetPassword && !_this.ApiService.isAdLogin && _this.adminInfo.source != 'AD'){
            _this.isResetPassword = true;
          }else{
            if(_this.adminInfo.permissions.length === 0){
              _this.$router.push({path: '/noPermission'});
              return false;
            }
            //updateCurrentNode:更新当前节点，如果是HQ系统当前节点没有权限就自动切换到All节点选项
            _this.updateCurrentNode(_this.adminInfo, () => {
            _this.getCurrentNode()
              // 获取当前节点的权限
              //判断是否为超级管理员
              _this.adminInfo.isSuperAdmin = _this.adminInfo.rolePermissionDtos.some(value => {
                return !value.targetNodeId;
              });
              // 超级管理员取所有权限，不是超级管理员就需要根据当前节点来获取权限
              if(!_this.adminInfo.isSuperAdmin){
                _this.adminInfo.permissionCodes = _this.getUserPermissionCodes(result);
              }else{
                _this.adminInfo.permissionCodes = _this.adminInfo.permissions;
              }
              _this.isHQ(); //判断是否为HQ系统做对应的处理
              if(_this.ApiService.isAdLogin){
                _this.$ajax.get('License/ExistsVaidLicense').then(res=>{
                  if(res.data.data){
                    _this.$ajax.get('License/AboutExpireLicense').then(res=>{
                      _this.$root.isExpireLicense = res.data.data;
                      _this.getUserMenu(_this.adminInfo.permissionCodes,callback);
                    })
                   }else{
                     _this.$router.push({path:'/licenseExpired'});
                     return false
                   }
                })
              }else{
                _this.$ajax.get('License/AboutExpireLicense').then(res=>{
                  _this.$root.isExpireLicense = res.data.data;
                })
                _this.getUserMenu(_this.adminInfo.permissionCodes,callback);
              }
            });
            _this.connectSignalr();
          }
          // 在获取了token了之后再请求接口
          _this.setIsEsopMode()
          _this.addRefreshAccessTokenTask();
          _this.getAllIncidentTypes();
     
        }else{
          _this.messageNotice('error','Exception in getting user information');
          if(callback && typeof callback === 'function'){
            callback(false);
          }
        }
      }).catch(()=>{
        if(callback && typeof callback === 'function'){
          callback(false);
        }
      });
    },
    // 提示无权限
    noticeNoPermission: function(){
      const NO_PERMISSION_NOTICE = 'You are not authorised to login this page';
      _this.messageNotice('error', NO_PERMISSION_NOTICE);
      if (_this.$route.path !== '/login') {
        _this.$router.push({path: '/login'});
      }
    },
    // 根据当前节点获取权限
    getUserPermissionCodes: function(result){ 
      let permissionCodes = result.permissions; // 在HQ系统是指所有节点的code的并集，在子系统指的是子系统的权限;
      //判断当前是否是All节点,不是All就需要根据权限获取权限
      if(_this.curNodeInfo.id !== null && result.rolePermissionDtos.length){
        let index = result.rolePermissionDtos.findIndex(value => value.targetNodeId === _this.curNodeInfo.syncNodeId);
        if(index > -1){
          permissionCodes = result.rolePermissionDtos[index].permissions;
        }
      }
      return permissionCodes;
    },
    // 获取节点信息
    getNodeList:function (callback) {
      this.$ajax.get('SyncNode/GetAll?filterByPermissionNode=true').then(function (res) {
        if(res.data.success){
          let nodesList = res.data.data;
          let nodeIds = nodesList.map(el => el.id);
          let keys = ['system.setting.node.card.main.type'];
          _this.ApiService.getMainCardType(nodeIds, keys);

          _this.nodes = JSON.parse(JSON.stringify(nodesList)); 
          _this.navNodes = nodesList;
           //设置主节点
           _this.masterNodeInfo = nodesList.find(item => item.isMaster);
          //将虚拟节点ALL添加到导航节点中
          if(_this.masterNodeInfo.id){ //有主节点才加入All
            _this.navNodes.unshift({id:null, name:'All'});
          }
        }
        if (callback && typeof callback === 'function') {
          callback();
        }
      }).catch(()=>{
        if (callback && typeof callback === 'function') {
          callback();
        }
      });
    },
    // 更新当前节点信息
    updateCurrentNode: function(adminInfo,callFun){
      let nodeInfo;
      if (adminInfo.displayNodeId) {//获取服务端保存的当前选择节点
        let curNodeInfo = _this.navNodes.find((item)=>{
          return item.id === adminInfo.displayNodeId;
        });
        // 如果服务端保存的当前选择节点没有权限，切换到All节点，防止无法进入系统
        if (!curNodeInfo) {
          nodeInfo = _this.navNodes[0];
        } else {
          nodeInfo = curNodeInfo;
        }
      }else{
        nodeInfo = _this.navNodes[0];
      }
      _this.curNodeInfo = nodeInfo;
      _this.getAllOffices();
      _this.shareApi.curNodeInfo = _this.curNodeInfo;
      _this.curNodeInfoUpdated = true;
      // 获取节点配置
      let isMasterNode = !_this.curNodeInfo || !_this.curNodeInfo.id;
      _this.ApiService.getAllConfigSetting((_this.curNodeInfo && _this.curNodeInfo.id) || _this.masterNodeInfo.id, isMasterNode,callFun);

    },
    getAllOffices(){
        let params = {sortName:'name',sortType:0,enabledPaging:false}
        if(_this.curNodeInfo.id){
          params.buildingIds = [_this.curNodeInfo.id];
        }
        _this.$ajax.post('Office/PagingOption',params).then(res=>{
          if(res.data.success){
            _this.offices = res.data.data.items;
            _this.navOffices =  JSON.parse(JSON.stringify(_this.offices));
            if(!_this.navOffices || ( _this.navOffices && _this.navOffices.length == 0 )){           
              _this.navOffices.unshift({name:'No Office',id:null});
              _this.curOfficeInfo = {name:'No Office',id:null};
            }else{
              _this.navOffices.unshift({name:'All Offices',id:null});
              _this.curOfficeInfo = {name:'All Offices',id:null};
            }
           
          }
        })
    },
    // 保存当前选择的节点信息
    saveCurrentNode: function(nodeId, callback){
      let params = {
        accountId: _this.adminInfo.id,
        nodeId: nodeId || '00000000-0000-0000-0000-000000000000'
      };
      this.$ajax.post('Accounts/SetAccountDisplayNode', params, {
        baseURL: window.g.VERIFICATION_ROOT,
        headers: {noLoading: true}
      }).then(function (res) {
        if (res.data.success) {
          console.log('success')
        }else{
          _this.messageNotice('error', res.data.message);
        }
        if(callback){
          callback()
        }
      }).catch(()=>{
        if(callback){
          callback()
        }
      });
    },
    // 更新节点是否有权限, 用于右上角隐藏无权限的节点
    updateNavNodes: function(){
      this.navNodes = _this.navNodes.filter(node => {
        return this.adminInfo.rolePermissionDtos.findIndex(value => value.targetNodeId === node.syncNodeId && value.permissions && value.permissions.length) > -1 || !node.syncNodeId;
      });
    },
    // 添加定时刷新任务
    addRefreshAccessTokenTask: function(){
      let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
      if( this.ApiService.refreshTokenTime && currentTime <= this.ApiService.refreshTokenTime ){
        let date1 = moment(this.ApiService.refreshTokenTime);
        let date2 = moment(currentTime);
        let duration = date1.diff( date2, 'seconds' ) * 1000;
        clearTimeout( updateTokenTimer );
        console.log("Add token task: " + duration + " ms")
        updateTokenTimer = setTimeout(()=>{
          if( _this.$route.path !== '/login' ){
            _this.refreshAccessToken();
          }
        }, duration);
      }
    },
    // 刷新Token
    refreshAccessToken: function () {
      // AD账号不刷新token
      if( _this.ApiService.isAdLogin ){
        return;
      }
      //1.首先判断AccessToken是否过期，如果过期的话，需要重新获取
      //2.判断AccessToken是否存在，如果不存在也要重新获取
      //3.获取AccesssToken需要refreshToken，如果refreshToken不存在则界面需要跳转到登录界面重新登录
      /*获取当前时间*/
      let currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
      if (!this.ApiService.refreshFlag && (!this.ApiService.accessToken || (this.ApiService.refreshTokenTime && (currentTime >= this.ApiService.refreshTokenTime))) && this.ApiService.refreshToken) {
        this.ApiService.refreshFlag = true;
      }else{
        return;
      }
      let data = new URLSearchParams({
        'grant_type': "refresh_token",
        'client_id': "ultimo.essential.web.client.v1",
        'client_secret':'secret',
        'refresh_token': _this.ApiService.refreshToken,
        'scope':'offline_access'
      });
      console.log(currentTime + ": Update Token ...")
      _this.$ajax.post('/connect/token', data, {baseURL: window.g.LOGIN_ROOT, headers:{noLoading: true } })
        .then(function (res) {
          if (res.data) {
            _this.connect.destroy();
            _this.ApiService.setQueryToken(res.data.token_type + ' ' + res.data.access_token, res.data.refresh_token, res.data.expires_in);
            _this.ApiService.refreshFlag = false;
            setTimeout(()=>{
              _this.ApiService.getLocalToken();
              console.log(_this.ApiService.accessToken);
            }, 500);       
            _this.connectSignalr();
          } else {
            _this.messageNotice('error', res.data.message);
          }
        }).catch(()=>{
          // 防止刷新token失败之后不会再刷新
        });
    },
    // 初始化获取所有信息
    getAll: function () {
      if(localStorage.getItem('isAdLogin')){
        _this.ApiService.isAdLogin = localStorage.getItem('isAdLogin') == 'true'
      }
      if ((this.ApiService.accessToken && window.location.hash !== '#/login') || _this.ApiService.isAdLogin) {
        _this.getNodeList(()=>{
          _this.getUserInfo(()=>{
            let detailLinkId = sessionStorage.getItem('detailLinkId')
                if(detailLinkId){
                  this.$ajax.get('IncidentRecord/GetByDetailLinkId?detailLinkId=' + detailLinkId).then((res)=>{
                    if(res.data.success){
                      _this.toIncidentDetail(res.data.data)
                      }else{
                        _this.messageNotice('error', res.data.msg);
                      }
                     sessionStorage.removeItem('detailLinkId')
                  })
                }
          });
        });
      }
    },
    toIncidentDetail(data){
      let obj = {
        isOpenDetails:true,
        obj:data
      }
      sessionStorage.setItem('incidentObj',JSON.stringify(obj))
      if(data.incidentCategory == 0){
        this.$router.replace({ name: 'My Alarm'});
      }
      if(data.incidentCategory == 1){
        this.$router.replace({ name: 'My Notification'});
      }
      if(data.incidentCategory == 2){
        this.$router.replace({ name: 'My Task'});
      }
    },
    // axios的token过滤器
    setInterceptor:function(){
      let requestAbortText = 'Request cancelled: ';
      axios.defaults.baseURL = window.g.API_ROOT;
      axios.interceptors.request.use(
        config => {
          if (config.url === window.g.LOGIN_ROOT + '/connect/token') {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
          }else if(_this.ApiService.isAdLogin){
            config.headers['Authorization-Type'] = 'Negotiate';
          }else if(_this.$router.history.current.path === '/notificationWindow'){
            config.headers['Authorization'] = localStorage.getItem('essAccessToken') ? localStorage.getItem('essAccessToken') : '';
          }else{
            config.headers['Authorization'] = _this.ApiService.accessToken;
          }
          // 是否打开加载页
          if (config.url && !config.headers.noLoading) {
            this.requestCount++;
            vm.$nextTick(() => {
              vm.isLoading = true;
            });
          }
          // 刷新接口期间,或者接口有code并且没有该codes数组中的权限，取消相关请求
          if(!config.cancelToken){
            let cancelReqFn = null;
            config.cancelToken = new axios.CancelToken(function executor(c) {
              _this.cancelReq = c;
              cancelReqFn = c;
            });
            if ( (_this.ApiService.refreshFlag && config.url.indexOf('/connect/token') === -1)) {
              if (_this.requestCount > 0 && !config.headers.noLoading) {
                _this.requestCount--;
              }
              _this.cancelReq(requestAbortText + config.url);
            }
          }
          return config;
        },
        error => {
          return Promise.reject(error)
        }
      );
      axios.interceptors.response.use(response =>{
        if(response.config.url !== window.g.LOGIN_ROOT + '/connect/token' && response.status !== 401 ){
          _this.refreshAccessToken();
        }
        if(response.status === 401){
          //判断是否在动态通知窗口界面，如果是则不需要自动跳转
          // if(_this.$router.history.current.path === '/notificationWindow'){
          //   _this.$root.loginModal = true;
          // }else{
          //   _this.$router.push({path: '/login'});
          // }
          _this.timeOutModal = true;
        }
        /*判断license是否过期*/
        if(response.status === 444){
          //判断是登陆后过期还是在操作过程中过期
          if(response.config.url === window.g.LOGIN_ROOT + '/Accounts/GetLoginAccountInfo'){
            _this.$router.push({path: '/uploadLicense'});
          }else{
            //在操作过中过期
            _this.licenseExpiredModal = true;
          }
        }
        if (!response.data.success &&  response.data.code === 401) {
          _this.timeOutModal = true;
        }
        // 更新当前请求数
        if (_this.requestCount > 0 && !response.config.headers.noLoading) {
          _this.requestCount--;
        }
        // 当前请求数为0时延迟关闭加载页
        if (_this.requestCount === 0) {
          _this.loadingTimer = setTimeout(()=>{
            if (_this.requestCount === 0) {
              _this.isLoading = false;
            }
          },_this.loadingTimerDuration);
        }
        return response
      },error => {
        // 更新当前请求数
        if (this.requestCount > 0 && error.config && !error.config.headers.noLoading) {
          this.requestCount--;
        }
        // 当前请求数为0时延迟关闭加载页
        if (_this.requestCount === 0) {
          _this.loadingTimer = setTimeout(()=>{
            if (_this.requestCount === 0) {
              _this.isLoading = false;
            }
          },_this.loadingTimerDuration);
          _this.isReviewAC = false;
        }
        if (error.response && error.response.status === 401) {
          //判断是否在动态通知窗口界面，如果是则不需要自动跳转
          // if(_this.$router.history.current.path === '/notificationWindow'){
          //   _this.$root.loginModal = true;
          // }else{
          //   _this.$router.push({path: '/login', params: {method: 'refresh'}});
          // }
          _this.timeOutModal = true;
        } else if(error.response && error.response.status === 403) {
          if(_this.ApiService.isAdLogin){
            _this.timeOutModal = true;
          }else{
            _this.messageNotice('error', 'No Permission');
          }
        } else if(error.response && error.response.status === 404){
          _this.messageNotice('error', 'Request address does not exist');
        } else if(error.response && error.response.status === 500){
          _this.messageNotice('error', 'Error encountered');
        } else if(error.response && error.response.data && error.response.data.error_description){
          if(!(error.response.data.error === 'account_locked' || error.response.data.error === 'account_passworderror_locked' || error.response.data.error === 'account_inactive' || error.response.data.error === 'account_passworderror')){
            _this.messageNotice('error', error.response.data.error_description);
          }
        } else if(_this.ApiService.refreshFlag || (error && error.message && error.message.indexOf(requestAbortText) > -1) || (error && !error.message)) {
          //取消请求不提示
        }else if(!error || !error.response || !error.response.data || !error.response.data.error_description){
          _this.messageNotice('error', 'No response from server');
        }
        return Promise.reject(error)
      })
    },
    /****************获取默认路由***************/
    //根据code获取菜单
    getMenuList(items, codes){
      return items.filter(item => {
        // 递归检查子项
        if (item.children && item.children.length > 0) {
            item.children = _this.getMenuList(item.children, codes);
        }
        // 是否是多个权限控制
        let hasDuplicates  =  false;
        if(item.codes && item.codes.length > 0){
          hasDuplicates = codes.some((code) => {
            return item.codes.indexOf(code) > -1;
          });
        }
        let children = [];
        if(item.children && item.children.length > 0){
          children = item.children.filter(child => !child.noRelevance);
        }
        // 检查当前项或其子项是否包含需要的code

        // return ((codes.includes(item.code) || (item.children && item.children.length > 0) || this.healthMenuListCode.indexOf(item.code) != -1 || this.baseHealthMonitoringMenu(item.code,codes)) && !item.noRelevance) || (hasDuplicates && item.noRelevance);
        return (codes.includes(item.code) || (children && children.length > 0) ||this.healthMenuListCode.indexOf(item.code) != -1 || this.baseHealthMonitoringMenu(item.code,codes) || this.resourceMenu(item.code,codes) || hasDuplicates);
      });
    },
    // 基础健康检测的权限结构和其他的不一样需要单独处理
    baseHealthMonitoringMenu(code,codes){
      let result = false
      if(code == 'M_HealthMonitoring'){
        let arr = ['M_ViewHealthOverview','M_ViewDeviceHealth','M_ViewInternalServiceHealth','M_ViewExternalSystemServiceHealth','M_ViewExternalSystemServerHealth']
        arr.forEach((item)=>{
          if( codes.includes(item)){
            result = true;
            return
          }
        })
      }
      return result

    },
    resourceMenu(code,codes){
      let result = false
      if(code == 'N_Resource'){
        let arr = [ 'M_ResourceManagement', 'M_ResourceMore']
        arr.forEach((item)=>{
          if( codes.includes(item)){
            result = true;
            return
          }
        })
      }
      return result

    },
    //获取登录用户菜单
    getUserMenu: function (permissionCodes,callback) { 
          let data = JSON.parse(JSON.stringify(menuData));
          // 按照需求esop处理事件不需要权限控制但是如果没有这个权限code的话路由无法生成，所以在生成路由的时候加进去
          _this.menu.menuList = _this.getMenuList(data,permissionCodes);
          permissionCodes.push('M_ProcessAlarm')
          let permission = _this.getPermission(permissionCodes, data, [], 0);
          //管理员权限
          let routeTree = permission.routes;
          // 由于处理事件不需要权限控制所以直接加入到路由中 由于由很多地方都可以进入esop 处理这个界面但是这个界面又与权限无关，如果按照之前的没有勾选incident模块但是其他地方想进来的话应该就会404
          routeTree.push({path: '/incidentProcess',name:'Process',meta: {}, component: resolve => require([`@/components/incidentManagement/processHandle/processHandle.vue`], resolve)});
          routeTree.push({path: '*', redirect: '/notFound', meta: {}});
          router.addRoutes(routeTree);
          // 登录后跳转到第一个路由
          let hasRoute = false;
          if ( _this.$route.path === '/login' && _this.menu.menuList.length > 0) {
            if( routeTree.length ){
              if( routeTree[0].path !== '/notificationWindow' ){
                _this.$router.push({path: routeTree[0].path});
                hasRoute = true;
              }else if( routeTree[1] ){
                _this.$router.push({path: routeTree[1].path});
                hasRoute = true;

              }
            }
          } else if (window.location.hash !== '#/login') {
            hasRoute = true;
          }
          if (!hasRoute) {
            _this.$router.push({path: '/noPermission'});
          }
          if(callback && typeof callback === 'function'){
            callback()
          }
    },
    // 加载权限
    getPermission: function (permissionCodes, array, routes, layer, firstMenuObj) {
      // 权限排序
      array.sort((a, b) => {
        return a.sort - b.sort;
      });
      array.forEach(value => {
        // 存储code
        if( layer === 0 ){
          firstMenuObj = {
            firstMenu: value.name,
            secondMenu:'',
            thirdMenu: '',
            forthMenu: ''
          }
        }else if( layer === 1 ){
          firstMenuObj.secondMenu = value.name;
        }else if( layer === 2 ){
          firstMenuObj.thirdMenu = value.name;
        }else if( layer === 3 ){
          firstMenuObj.forthMenu = value.name;
        }
        let routeObj = {
          children: []
        };
        // 添加route信息
        if (value.module && value.route) {
          routeObj = {
            path: value.route,
            name: value.name,
            meta:{
              layer: layer,
              code: value.code,
              permissionType: value.permissionType,
              firstMenu: firstMenuObj.firstMenu,
              secondMenu: firstMenuObj.secondMenu,
              thirdMenu: firstMenuObj.thirdMenu,
              forthMenu: firstMenuObj.forthMenu,
              keepAlive: routeConfig.keepAliveRoutes.indexOf(value.route) > -1
            },
            children:[],
            component: resolve => require([`@/components/${value.module}.vue`], resolve)
          };
          routes.push(routeObj);
        }
        // 递归处理子级
        if (value.children && value.children.length > 0) {
          _this.getPermission(permissionCodes, value.children, (value.isTabRoute ? routeObj.children : routes), layer + 1, JSON.parse( JSON.stringify( firstMenuObj ) ) );
        }
      });
      return {routes: routes};
    },
    //更多操作
    openMoreOperation: function (e) {
      e.stopPropagation();
      setTimeout(() => {
        let bigBox = $(e.target).parents('#app')[0];
        //提示框的高度
        let operationHeight = $(e.target).parents('.utm-box').siblings('.utm-left-more-operation')[0].offsetHeight;
        let navWidth = $('#menu')[0].offsetWidth;
        //判断提示框是否超出屏幕
        if (bigBox.offsetHeight + bigBox.offsetTop < (e.pageY - e.layerY) + 32 + operationHeight) {
          $(e.target).parents('.utm-box').siblings('.utm-left-more-operation').css({
            'left': e.pageX - navWidth + 12,
            'top': (e.pageY - e.layerY) - operationHeight
          }).fadeIn();
        } else {
          $(e.target).parents('.utm-box').siblings('.utm-left-more-operation').css({
            'left': e.pageX - navWidth + 12,
            //'top': (e.pageY - e.layerY) + 32
            'top': (e.pageY - e.layerY) - operationHeight -32
          }).fadeIn();
        }
      }, 200);
    },
    //链接signalr
    connectSignalr: function () {
      console.log('connectSignalr')
      let options = {
        signalrPath: window.g.SIGNALR_ROOT,
        userId: _this.$root.adminInfo.id,
        token: _this.ApiService.accessToken,
        //实时获取事件推送的消息
        receiveMessage: function (message) {
          if(_this.timeOutModal){
            return false
          }
          message = JSON.parse(message);
          let newMessage = {
            id:message.incidentRecordId,
            incidentName: message.title,
            category: message.category,
            content: message.content,
            createTime: message.time,
            timeZoneId: message.timeZoneId,
            level: message.level,
            type: message.incidentType,
            status: message.Status,
            messageId: message.incidentRecordId,
            color:message.color,
            isAutoDisappear: message.isAutoDisappear,
            disappearDelayTime: message.disappearDelayTime,
            canPlayBackVideo: message.canPlayBackVideo,
            canPlayAudio: message.canPlayAudio,
            playAudioType: message.playAudioType,
            mapId: message.mapId,
            accessZoneId: message.accessZoneId,
            vehicle: message.vehicle || {},
            tags: message.tags || [],
            isShowUserTags: message.isShowUserTags,
            armingAreaId:message.armingAreaId
          };
          _this.unreadMessageCount = _this.unreadMessageCount + 1;
          let realTimeMessageRoles = ['M_ViewMyAlarm','M_ViewMyTask','M_ViewMyNotification']
          //右下角事件实时消息
          if( realTimeMessageRoles.some(value => _this.adminInfo.permissionCodes.includes(value))){
            eventBus.$emit('realTimeMessageArrived', newMessage);
          }
          // alarm map接收消息
          eventBus.$emit('realTimeMessageArrivedForAlarmMap', newMessage);
          //armingDashboard接收消息
          eventBus.$emit('realTimeMessageForRoute', newMessage);
        },
        //监控区域统计实时刷新
        monitoringAreaPeopeleCountChange:function(newMessage){
          eventBus.$emit('MonitoringAreaPeopeleCountChange', newMessage);
        },
        //esop处理中后端通知事件超时状态被改变需要
        EsopTaskStatusChanged:function(newMessage){
          eventBus.$emit('EsopTaskStatusChanged', newMessage);
        },
        //esop处理中后端通知节点已经被处理了需要刷新页面
        EsopAlarmRefresh:function(newMessage){
          eventBus.$emit('EsopAlarmRefresh', newMessage);
        },
        //esop处理中后端通知事件已经被关闭
        EsopAlarmClosed:function(newMessage){
          eventBus.$emit('EsopAlarmClosed', newMessage);
        },
        //esop处理中后端通知事件等级被修改
        UpdateIncidentRecordLevel:function(newMessage){
          eventBus.$emit('UpdateIncidentRecordLevel', newMessage);
        },
        // 结束会议
        closeCall:function(newMessage){
          eventBus.$emit('closeCall', newMessage); 
        },
      };
      _this.connect.msgConnect(this.signalr, options);
      _this.connect.passportReader();
    },

    // 获取table显示最大高度
    getTableMaxHeight: function () {
      this.$nextTick(() => {
        if($('.utm-box-right').height()){
          let height1 = $('.utm-box-right').height();
          /*右侧内容高度*/
          let height2 = $('.utm-page-inquire').height() ? $('.utm-page-inquire').height() + 32 : 0;//有界面没有搜索区域，所以需要特殊处理
          /*过滤列表高度*/
          this.tableMaxHeight = height1 - height2 - 74;
        }else{
          this.tableMaxHeight = $('.record-content').height() -74;
        }
        if($('.utm-table').length>0) {
          $('.utm-table .ivu-table-body').scrollTop(0);/*将滚动条重置到0，避免翻页后固定列与其他列数据错位*/
          $('.utm-table .ivu-table-body').scrollLeft(1);/*将横向滚动条重置到1，避免从搜索后无数据到有数据 固定列与其他列数据错位*/
        }
      })
    },
    // 查看大图
    viewBigImg: function (url) {
      this.viewBigImage.srcStr = url;
      this.viewBigImage.bigImgModal = true;
    },

    // 获取user IC保留位数
    getICKeepFigure:function () {
      this.$ajax.get('DataDictionary/GetIdentityCardSetting').then(function (res) {
        if(res.data.success){
          _this.icKeepFigures = (res.data.data.keepFigures ? res.data.data.keepFigures : 0);
        }
      })
    },

    // 把配置的事件加入common文件的事件类型里
    getAllIncidentTypes:function(){
      let arr = [
        {
          type: 0,
          listKey: 'alarmList',
        },
        {
          type: 1,
          listKey: 'notificationList',
        },
        {
          type: 2,
          listKey: 'taskList',
        }
      ];
      let hiddenIncidentTypes = _this.ApiService.hiddenIncidentTypes || [];
      let common = _this.$root.common;
      let types = common.incidentType;
      arr.forEach((item)=>{
        _this.$ajax.get('Incident/GetConfigs?isAll=true&isOnlySubNode=true&category=' + item.type ).then((res)=> {
          if( res.data.success ){
            let typeList = [];
            res.data.data.forEach((item)=>{
              item.targetItems.forEach((group)=>{
                group.items.forEach((incident)=>{
                  types[incident.incidentType] = incident.name;
                  if (hiddenIncidentTypes.indexOf(incident.incidentType) === -1) {
                    typeList.push({
                      label: incident.name,
                      value: incident.incidentType
                    });
                  }
                });
              });
            });
            common.incidentType = types;
            typeList.sort((a, b)=>{
              return (a.label > b.label) - (b.label > a.label);
            });
            common[item.listKey] = typeList;
            _this.$root.common = common;
          }else{
            _this.messageNotice('error', res.data.message);
          }
        })
      })
    },

    // 获取最新未读消息
    getUnreadMessage: function () {
      let searchInfo = {};
      let date = this.moment(new Date(), 'YYYY-MM-DD').format(_this.$root.Time[_this.$root.Time.type].typeDateStr);
      searchInfo.startTime = _this.common.formatDate(date + ' 00:00:00',_this.$root.Time[_this.$root.Time.type].typeTime,2);
      searchInfo.endTime = _this.common.formatDate(date + ' 23:59:59',_this.$root.Time[_this.$root.Time.type].typeTime,2);
      searchInfo.queryNodeId = _this.curNodeInfo.id;
      this.$ajax.post('IncidentRecord/GetUnReaderOrUnProcessCount', searchInfo,{headers: {noLoading: _this.ApiService.refreshToken !== ''}}).then(function (res) {
        if (res.data.success) {
          _this.$root.unreadMessageCount = res.data.data;
        } else {
          _this.$root.unreadMessageCount = 0;
        }
      })
    },
  }
});
Vue.prototype._vmObject = vm;
router.beforeEach(function (to, from, next) {
  // esop处理的路由限制不受权限控制所以搜索条件的缓存不符合限制的逻辑
  let isProcess =  (to.name == 'Process' && from.name == 'My Alarm') || (from.name == 'Process' && to.name == 'My Alarm')
  // 路由跳转搜索条件保留/清空判断 1.两个路由的父级不相同时 2.不是同一路由路由类型不相同(菜单 > 功能);
  if((from.meta.layer === to.meta.layer || from.meta.secondMenu !== to.meta.secondMenu || (from.meta.code !== to.meta.code && from.meta.permissionType === to.meta.permissionType)) && !isProcess){
    _this.ApiService.cacheSearchInfo = {};
  }  
  _this.isTablePagerfixed = false;
  // 切换到登录页面清空用户信息
  if (to.path === '/login' && _this.ApiService.accessToken){
    _this.menu.navTitle = '';
    _this.menu.childTitle = '';
    _this.menu.thirdTitle = '';
    _this.menu.forthTitle = '';
    _this.adminInfo = {
      permissionCodes:[]
    }
    // 清除某时间刷新token的任务
    clearTimeout( updateTokenTimer );
    _this.connect.destroy();
    _this.ApiService.clearToken();
    next();
  }
  // 没有token的内容页面,跳转到404
  else if((to.path !== '/login' && to.path !== '/notFound' && !_this.ApiService.accessToken && !_this.ApiService.isAdLogin) ||
  (to.path === '/PalmVeinReport' && !_this.ApiService.palmVeinInfo.userTypes.length)){
    next('/notFound');
    return false;
  }
  //权限控制,没有当前路由的code的内容页面,跳转到notFound
  
  else if( to.path !== '/login' && to.path !== '/notFound' && to.meta.code && 
  _this.adminInfo.permissionCodes.indexOf( to.meta.code ) === -1 && 
  _this.healthMenuListCode.indexOf(to.meta.code) == -1 &&
   !_this.baseHealthMonitoringMenu(to.meta.code,_this.adminInfo.permissionCodes) &&
   !_this.resourceMenu(to.meta.code,_this.adminInfo.permissionCodes)
   && to.meta.code != 'M_ProcessAlarm'     
  ){
    next('/notFound');
    return false;
  }
  else{
   // User Record跳转
    if(to.path === '/userRecord' && from.meta.firstMenu === 'User'){
     to.meta.secondMenu = from.meta.secondMenu;
   }
   _this.menu.navTitle = to.meta.firstMenu;
   _this.menu.childTitle = to.meta.secondMenu;
   _this.menu.thirdTitle = to.meta.thirdMenu;
   _this.menu.forthTitle = to.meta.forthMenu;
   next();
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/admin/main.js
// module id = LWJm
// module chunks = 15